export enum VisualizationDataPointCapability {
  filterable = 1,
}